import { render, staticRenderFns } from "./HomeClosingSection.vue?vue&type=template&id=182556f5"
import script from "./HomeClosingSection.vue?vue&type=script&lang=js"
export * from "./HomeClosingSection.vue?vue&type=script&lang=js"
import style0 from "./HomeClosingSection.vue?vue&type=style&index=0&id=182556f5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports